import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=fb6a29bc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=fb6a29bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a29bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6a29bc')) {
      api.createRecord('fb6a29bc', component.options)
    } else {
      api.reload('fb6a29bc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=fb6a29bc&scoped=true&", function () {
      api.rerender('fb6a29bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TN2Ec1A9uoO2/JS/comp/PopupBox.vue"
export default component.exports